export type CollegeProfileSectionId =
  | "general-details"
  | "basic-information"
  | "email-types"
  | "parent-email-rules-client-rules"
  | "parent-email-rules-system-rules";

export type CollegeProfileNavItem = {
  id: CollegeProfileSectionId;
  label: string;
};

export type CollegeProfileNavGroup = {
  id: string;
  label: string;
  children: CollegeProfileNavItem[];
};

export const COLLEGE_PROFILE_NAV_ITEMS: (CollegeProfileNavItem | CollegeProfileNavGroup)[] = [
  { id: "general-details", label: "Client overview" },
  { id: "basic-information", label: "Basic information" },
  { id: "email-types", label: "Email types" },
  {
    id: "parent-email-rules",
    label: "Parent email rules",
    children: [
      { id: "parent-email-rules-client-rules", label: "Client rules" },
      { id: "parent-email-rules-system-rules", label: "System rules" },
    ],
  },
];

export const DEFAULT_COLLEGE_PROFILE_SECTION_ID: CollegeProfileSectionId = "general-details";
